<script lang="ts">
	import { onNavigate } from '$app/navigation';

	let loading = $state(false);

	onNavigate((navigation) => {
		loading = true;
		navigation.complete.then(() => {
			loading = false;
		});
	});
</script>

{#if loading}
	<!-- Top progress bar for immediate feedback -->
	<div class="fixed top-0 left-0 right-0 z-[60] h-1 bg-transparent overflow-hidden">
		<div class="h-full bg-ameta-green animate-progress-bar"></div>
	</div>
{/if}

<style>
	@keyframes progress-bar {
		0% {
			width: 0%;
		}
		20% {
			width: 30%;
		}
		50% {
			width: 60%;
		}
		80% {
			width: 85%;
		}
		100% {
			width: 95%;
		}
	}

	.animate-progress-bar {
		animation: progress-bar 2s ease-out forwards;
	}
</style>
